<div class="mable-section">
  <mable-heading
    class="ion-margin-horizontal"
    heading="h2"
    headingStyle="h3"
    >Support services</mable-heading
  >
  <mable-input
    label="Service description"
    [hasError]="serviceDescription?.showError()"
    data-testid="agreement-form-step2-service-description"
  >
    <p
      class="description"
      id="servicesDescription"
    >
      Describe the support services you'll provide and the location.
    </p>
    <ion-textarea
      autocapitalize="sentences"
      rows="4"
      [formControl]="serviceDescription"
      (ionChange)="onServiceDescriptionChange()"
      placeholder="Enter services. e.g. Mondays from 9am - 12pm from 20th March. Cleaning, preparing lunch and assistance with personal grooming."
      autocomplete="on"
      autocorrect="on"
      spellcheck="true"
      data-testid="agreement-form-step2-service-description-textarea"
      aria-labelledby="servicesDescription"
    >
    </ion-textarea>
    <p
      class="warn"
      *ngIf="serviceDescription?.errors?.required"
    >
      Please enter agreed service details
    </p>
  </mable-input>
  <app-collapsible [title]="'Examples'">
    <ng-container class="content">
      <div>
        <span>Example 1</span>
        <p class="text-italic">
          ”I'll support John with getting ready to go to a physio appointment on Wednesdays and Fridays. I'll arrive an
          hour before the appointment to help him to get ready, which could include assistance with dressing and
          toileting. Then I'll drive him to the appointment using my car. During the appointment, I'll wait in
          reception. After the appointment I'll drive him home and we'll spend time in the garden or play games until a
          member of John's family comes over to start meal prep.”
        </p>

        <span>Example 2</span>
        <p class="text-italic">
          ”My primary role will be to provide social support, companionship and leisure activities for Sonia. Support
          will take place at Sonia's home or, if we go out, I'll drive Sonia in my car. Sonia will cover the cost of any
          activities and parking expenses. I will provide my own mobile phone and my vehicle.”
        </p>
      </div>
    </ng-container>
  </app-collapsible>
</div>
